import { EditableWorkspaceCards } from "../cards/EditableWorkspaceCards";
import { I18n } from "@/i18n/I18n";

export function AllWorkspaces() {
  return (
    <div className="p-3 overflow-auto" style={{ maxHeight: '100vh', height: '100vh' }}>
      <div className="pb-3">
        <h1>{I18n.get('workspaces')}</h1>
      </div>
      <EditableWorkspaceCards />
    </div>
  );
}
